/* eslint-disable @typescript-eslint/no-unused-vars */
/* eslint-disable react/react-in-jsx-scope */
import FormControlLabel from '@mui/material/FormControlLabel'
import Radio from '@mui/material/Radio'
import RadioGroup from '@mui/material/RadioGroup'
import Typography from '@mui/material/Typography'

import FormNumberInput from '../../../components/forms/elements/FormNumberInput'
import FormTextInput from '../../../components/forms/elements/FormTextInput'
import { REFUND_PAYMENT_MODES } from '../../../constants/models'

const Content = ({ values, formDisabled, handlePaymentModeChange }) => [
  {
    id: 'refund-user-form-details',
    name: 'Account details',
    inputs: [
      {
        id: 'paymentMode',
        size: 12,
        field: (
          <RadioGroup
            name="paymentMode"
            value={values.paymentMode}
            onChange={handlePaymentModeChange}>
            {Object.keys(REFUND_PAYMENT_MODES).map((mode: string) => {
              return (
                <FormControlLabel
                  key={`paymentOptions-${mode}`}
                  value={mode}
                  disabled={formDisabled}
                  control={<Radio />}
                  label={
                    <div style={{ display: 'flex' }}>
                      <img
                        height={40}
                        src={`${window.location.origin}/images/${REFUND_PAYMENT_MODES[mode].image}`}
                        alt={`Paymongo ${REFUND_PAYMENT_MODES[mode].name}`}
                      />
                      <Typography
                        sx={{ lineHeight: '40px', marginLeft: '10px' }}>
                        {REFUND_PAYMENT_MODES[mode].name}
                      </Typography>
                    </div>
                  }
                />
              )
            })}
          </RadioGroup>
        ),
      },
      {
        id: 'amountPaid',
        size: 12,
        field: (
          <FormNumberInput
            name="amountPaid"
            label="Amount Paid"
            required
            autoComplete="new-amountPaid"
            disabled={formDisabled}
          />
        ),
      },
      {
        ...(values.paymentMode === REFUND_PAYMENT_MODES.BANK.key && {
          id: 'bankName',
          size: 12,
          field: (
            <FormTextInput
              name="bankName"
              label="Bank Name"
              required
              autoComplete="new-bankName"
              disabled={formDisabled}
            />
          ),
        }),
      },
      {
        ...(values.paymentMode === REFUND_PAYMENT_MODES.BANK.key && {
          id: 'accountName',
          size: 12,
          field: (
            <FormTextInput
              name="accountName"
              label="Account Name"
              required
              autoComplete="new-accountName"
              disabled={formDisabled}
            />
          ),
        }),
      },
      {
        id: 'accountNumber',
        size: 12,
        field: (
          <FormTextInput
            name="accountNumber"
            label={
              values.paymentMode === REFUND_PAYMENT_MODES.BANK.key
                ? 'Account Number'
                : 'GCash Number'
            }
            required
            autoComplete="new-accountNumber"
            disabled={formDisabled}
          />
        ),
      },
    ],
  },
]

export default Content
